import React, { PureComponent, PropTypes } from 'react';
import { Link } from 'react-router';
import Nav, {
  AkContainerItem,
  AkContainerItemGroup,
  AkContainerTitle,
  AkSearchDrawer,
} from '@atlaskit/navigation';

import DashboardIcon from '@atlaskit/icon/glyph/dashboard';
import SearchIcon from '@atlaskit/icon/glyph/search';
import ArrowleftIcon from '@atlaskit/icon/glyph/arrow-left';
import AtlassianIcon from '@atlaskit/icon/glyph/atlassian';
import WorldIcon from '@atlaskit/icon/glyph/world';
import BitbucketIcon from '@atlaskit/icon/glyph/bitbucket';
import JiraIcon from '@atlaskit/icon/glyph/jira';
import PullRequestsIcon from '@atlaskit/icon/glyph/bitbucket/pullrequests';
import GearIcon from '@atlaskit/icon/glyph/settings';
import SearchDrawer from '../components/SearchDrawer';

import nucleusImg from '../images/nucleus.png';
import { BASE_URL } from '../config';

const internalLinks = [
  [`${BASE_URL}/`, 'Welcome', WorldIcon],
  [`${BASE_URL}/components.html`, 'Components', DashboardIcon],
];

const externalLinks = [
  ['https://bitbucket.org/atlassian/atlaskit', 'Bitbucket repo', BitbucketIcon],
  ['https://ecosystem.atlassian.net/browse/AK', 'JIRA project', JiraIcon],
];

const ContainerHeader = () => <Link to="/">
  <AkContainerTitle
    text="AtlasKit Registry"
    icon={<img alt="nucleus" src={nucleusImg} />}
  />
</Link>;

export default class RegistryNavigation extends PureComponent {
  state = {
    navLinks: [
      ['/', 'Home', DashboardIcon],
      ['/pull-requests', 'Pull requests', PullRequestsIcon],
      ['/settings', 'Settings', GearIcon],
    ]
  }

  static contextTypes = {
    navOpenState: PropTypes.object,
    router: PropTypes.object,
  };

  openDrawer = (openDrawer) => {
    this.setState({ openDrawer });
  }

  shouldComponentUpdate(nextProps, nextContext) {
    return true;
  };

  render() {
    const backIcon = <ArrowleftIcon label="Back icon" size="small" />;
    const globalPrimaryIcon = <AtlassianIcon label="Atlassian icon" size="medium" />;

    return (
      <Nav
        width={this.props.navigationWidth}
        isOpen={this.props.isNavigationOpen}
        onResize={this.props.onNavResize}
        containerHeaderComponent={() => <ContainerHeader />}
        globalPrimaryIcon={
          <AtlassianIcon size="medium" label="Atlassian" />
        }
        drawers={[
          <AkSearchDrawer
            backIcon={backIcon}
            isOpen={this.props.isSearchDrawerOpen}
            key="search"
            onBackButton={() => this.props.onSearchDrawerToggle(false)}
            primaryIcon={globalPrimaryIcon}
          >
            <SearchDrawer
              onResultClicked={() => this.props.onSearchDrawerToggle(false)}
              onSearchInputRef={(ref) => {
                this.searchInputRef = ref;
              }}
            />
          </AkSearchDrawer>
        ]}
        globalSearchIcon={<SearchIcon label="Search icon" />}
        drawerBackIcon={<ArrowleftIcon label="Back icon" size="medium" />}
        isResizeable={false}
        hasBlanket
        onSearchDrawerOpen={() => {
          this.props.onSearchDrawerToggle(true);
          if (this.searchInputRef) {
            this.searchInputRef.focus();
          }
        }}
        openDrawer={false}
      >
        {
          internalLinks.map(([url, title, Icon]) => (
            <Link key={url} to={url}>
              <AkContainerItem
                icon={<Icon label={title} size="small" />}
                text={title}
                isSelected={this.context.router.isActive(url, true)}
              />
            </Link>
          ))
        }
        <AkContainerItemGroup title="External resources">
          {
            externalLinks.map(([ url, title, Icon ]) => (
              <a key={url} href={url} target="_new">
                <AkContainerItem
                  icon={<Icon label={title} size="small" />}
                  text={title}
                  isSelected={this.context.router.isActive(url, true)}
                />
              </a>
            ), this)
          }
        </AkContainerItemGroup>
      </Nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistryNavigation.jsx